import config from "../config/config";
const { URL } = config;

export default function buildImageUrl(filename, entity = 'events') {
  return filename ? `${URL.TICKETGO_APP_URL_BACK}/${entity}/custom/image?filename=${encodeURIComponent(filename)}` : null;
}
